import React, { useState, useEffect } from "react";
import { useAuth } from "../context/contextAuth";
import { Link } from "react-router-dom";
import LogoImg from "../assets/img/logo/Save-Logo-Blue-2.png";

const ForgotPassword = () => {
  const {
    error,
    loadingAuth,
    email, setEmail,
    mailSent, setMailSent,
    sendForgotEmail
  } = useAuth();

  useEffect(() => {
    document.body.style.backgroundImage =
      "radial-gradient(circle at center, #302158, #100021)";
    document.body.style.height = "100vh";
    document.body.style.margin = "0";
    document.body.style.overflow = "hidden";
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await sendForgotEmail(email);
    } catch (error) {
      console.error("Error sending forgot email:", error);
    }
  };

  return (
    <div className="position-fixed top-50 start-50 translate-middle w-100 d-flex justify-content-center">
      <div
        className="bg-white rounded-4 shadow-lg p-5"
        style={{ maxWidth: 420, width: "95%" }}
      >
        {/* Logo */}
        <div className="text-center mb-4">
          <img src={LogoImg} alt="Logo" height={50} />
        </div>

        {!mailSent ? (
          <>
            {/* Header */}
            <div className="text-center mb-4">
              <h4 className="fw-bold text-dark">
                Forgot Password?
              </h4>
              <p className="text-secondary small">
                Enter your registered email to receive a secure reset link.
              </p>
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label small fw-semibold">
                  Email Address
                </label>
                <input
                  type="email"
                  className="form-control rounded-3 bg-light"
                  placeholder="user@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              {error && (
                <div className="alert alert-danger small text-center">
                  {error}
                </div>
              )}

              <button
                type="submit"
                className="btn w-100 fw-bold rounded-3 mt-2"
                disabled={loadingAuth}
                style={{
                  backgroundColor: "#0ea5e9",
                  color: "#fff",
                  padding: "12px"
                }}
              >
                {loadingAuth ? "Processing..." : "Reset Password"}
              </button>

              <div className="text-center mt-4 small text-secondary">
                Remembered your password?{" "}
                <Link
                  to="/signin"
                  className="text-decoration-none fw-semibold"
                  style={{ color: "#0ea5e9" }}
                >
                  Sign In
                </Link>
              </div>
            </form>
          </>
        ) : (
          <div className="text-center py-4">
            <div
              className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4"
              style={{
                width: 80,
                height: 80,
                background: "#f0f9ff",
                color: "#0ea5e9",
                fontSize: "2rem"
              }}
            >
              📩
            </div>

            <h4 className="fw-bold text-dark">
              Check your email
            </h4>

            <p className="text-secondary small">
              We've sent recovery instructions to <br />
              <strong>{email}</strong>
            </p>

            <Link
              to="/signin"
              className="fw-bold text-decoration-none"
              style={{ color: "#0ea5e9" }}
              onClick={() => {
                setMailSent(false);
                setEmail("");
              }}
            >
              ← Return to Sign In
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;